import { render, staticRenderFns } from "./EcommerceProfitChart.vue?vue&type=template&id=027bbae1"
import script from "./EcommerceProfitChart.vue?vue&type=script&lang=js"
export * from "./EcommerceProfitChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports